import React, { useEffect, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { getQueryStringParams } from '../../utils/utils'

import LanguageInputSection from '../../components/SelectLanguage'
import AutoSearchReservation from '../../components/AutoSearchReservation'
import Loading from '../../components/Loading'

import { cancelReservation } from '../../services/CancelReservation'
import { verifyReservationWithRA } from '../review-rental-agreement/api'

export default function SecondTryCheckInPage(props) {
  const { setKioskCurrentStationId, setPickupDate, appVersionId } = useContext(DomainContext);

  const [langInput, setLangInput] = useState(true)
  const [lang, setLang] = useState(null)

  const [searchParams, setParams] = useState(null)

  const [proceedCheckIn, setProceedCheckIn] = useState(false)

  const [cancelReservation, setCancelReservation] = useState(false)

  function handleLanguageChange(value) {
    setLang(value)
    setLangInput(false)
  }

  useEffect(() => {
    const queryStringValues = getQueryStringParams(
      props.location && props.location.search ? props.location.search : null
    )

    if (!queryStringValues || !queryStringValues.number || !queryStringValues.pickupStation || !queryStringValues.pickupDate || !queryStringValues.clientId) {
      return props.history.push(`/input-reservation-ref-error?resReference=`)
    }

    setKioskCurrentStationId(queryStringValues.pickupStation)
    setPickupDate(queryStringValues.pickupDate)

    setParams({ ...queryStringValues, appVersionId })
  }, [])

  function handleCancelClick() {
    setCancelReservation(true)
  }

  function handlePushToStart() {
    props.history.push('/start')
  }

  const displaySection = () => {
    const params = { ...searchParams, lang }

    if (langInput)
      return <LanguageInputSection onChange={handleLanguageChange} handleLogoClick={handlePushToStart} />

    if (proceedCheckIn)
      return (
        <AutoSearchReservation
          params={params}
          secondTry={true}
          handleNotFound={(err) => {
            const errorMessage = err?.message || err || null
            props.history.push({ pathname: `/input-reservation-ref-error`, search: `resReference=${params.number}`, state: { errorMessage } })
          }}
          handleFound={() => props.history.push('/review-reservation')}
          handleRAFound={(number, pickupStation, pickupDate) => {
            props.history.push(`/review-rental-agreement?number=${number}&pickupStation=${pickupStation}&pickupDate=${pickupDate}`)
          }}
        />
      )

    if (cancelReservation) return <CancelReservationSection handleLogoClick={handlePushToStart} params={params} />

    return (
      <ReservationMenu
        handleCheckInClick={() => setProceedCheckIn(true)}
        handleLogoClick={handlePushToStart}
        handleCancelClick={handleCancelClick}
      />
    )
  }

  return (
    <main>
      <div className="container">
        <div>
          {displaySection()}
        </div>
      </div>
    </main>
  )
}

function ReservationMenu({ handleLogoClick, handleCancelClick, handleCheckInClick, }) {
  const { t } = useTranslation()

  return (
    <div className="main">
      <div className="home-top text-center pt-4">
        <div className="container">
          <div onClick={handleLogoClick}>
            <img src={require(`../../assets/images/logo.png`)} alt="Guerin" />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-8">
            <div onClick={handleCheckInClick} className="btn btn-green w-100 p-3 mb-3 upper">
              {t('proceedCheckIn')}
            </div>
          </div>
          <div onClick={handleCancelClick} className="col-8">
            <div className="btn btn-green w-100 p-3 upper">
              {t('cancelReservation')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function CancelReservationSection({ handleLogoClick, params }) {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(true)

  const [message, setMessage] = useState('')

  useEffect(() => {
    cancelReservation(params)
      .then((result) => {
        setLoading(false)
        setMessage(result ? t('cancelReservationSuccess') : t('cancelReservationFailed'))
      })
      .catch(e => {
        setLoading(false)
        setMessage(t('cancelReservationFailed'))
      })
  }, [])

  return (
    <div className="main">
      <div className="home-top text-center pt-4">
        <div className="container">
          <div onClick={handleLogoClick}>
            <img src={require(`../../assets/images/logo.png`)} alt="Guerin" />
          </div>
        </div>
      </div>
      {loading ? <Loading active={loading} message={t('cancelingReservation')} /> :
        <div className="container">
          <div className="row justify-content-center" style={{ fontSize: '18px' }}>{message}</div>
        </div>
      }
    </div>
  )
}